var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100"},[_c('div',{staticClass:"align-self-center content-wrap-small content-pad text-center"},[_c('dx-error')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }